import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
export const VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BarcodeGenerationComponent),
  multi: true,
};

@Component({
    selector: 'asap-barcode-generation',
    templateUrl: './generation.html',
    styleUrls: ['./generation.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [VALUE_ACCESSOR],
    host: {
        class: 'asap-barcode-generation',
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BarcodeGenerationComponent implements OnInit, OnChanges, ControlValueAccessor {
  _inputBarcode = new FormControl();
  _isAutoGeneratingNumber: boolean;

  constructor(
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
  ) { }

  @Input() placeholder: string;
  @Input() entityName: string;
  @Input() icon: string;
  @Input() value: string;
  @Input() disabled:boolean;
  @Input() quantity: number = 1;

  @Output() valueChange: EventEmitter<string> = new EventEmitter();

  ngOnInit() {
    this._inputBarcode.valueChanges.subscribe((v) => {
      this.onTouched();
      this.onChange(v);

      this.valueChange.emit(v);
    });
    this._barcodeGeneratorsService
      .getBarcodeEnabled(this.entityName)
      
      .subscribe((data: any) => {
        this._isAutoGeneratingNumber = data;
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value && this.value !== this._inputBarcode.value) {
      this._inputBarcode.setValue(this.value);
    }
  }

  generateNumber(e: any) {
    this._barcodeGeneratorsService
      .getBarcode(this.entityName, this.quantity)
      
      .subscribe((data: any) => {
        this._inputBarcode.setValue(data.result.toString());
      });
  }

  //#region ControlValueAccessor impl

  onChange = (_: any) => { };
  onTouched = () => { };

  registerOnChange(fn: (_: any) => void) {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => {}) {
    this.onTouched = fn;
  }

  writeValue(value: string): void {
    this._inputBarcode.setValue(value, { emitEvent: false });
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this._inputBarcode.disable() : this._inputBarcode.enable();
  }

  //#endregion
}
